import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/Flare-Backoffice-Nextjs/app/(site)/products/embed-and-analytics/EmbedAndAnalyticsClient.jsx");
